import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigateToList } from '@/hooks/useNavigateToList'
import { Box, Card, CardHeader, CardBody, Heading, Text, Spinner, VStack } from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { BookingForm } from '@/components/forms/BookingForm'

export default function BookingEditPage() {
  const colors = useThemeColors()
  const navigateToList = useNavigateToList('/bookings')
  const { id } = useParams<{ id: string }>()
  const [bookingId, setBookingId] = useState<number | null>(null)
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!id) {
      navigateToList({ replace: true })
      return
    }

    const parsedId = Number(id)
    if (Number.isNaN(parsedId)) {
      navigateToList({ replace: true })
      return
    }

    setBookingId(parsedId)
    setIsValidating(false)
  }, [id, navigateToList])

  const handleSuccess = () => {
    navigateToList()
  }

  const handleCancel = () => {
    navigateToList()
  }

  if (isValidating || bookingId === null) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Booking</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update booking details
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <BookingForm bookingId={bookingId} onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
